<div
  *transloco="let t; read: 'action-plan-side-pane-item'"
  class="action-plan-side-pane-item__container"
>
  <div class="action-plan-side-pane-item__header">
    <mat-icon
      class="pointer"
      (click)="onToggleExpand()"
      [ngClass]="
        isExpanded
          ? 'action-plan-side-pane-item__expand-icon--open'
          : 'action-plan-side-pane-item__expand-icon--closed'
      "
      >expand_more</mat-icon
    >

    <span class="action-plan-side-pane-item__name">
      <ng-container *appMiddleEllipsize="name"></ng-container>
    </span>

    <xi-icon-button
      [disabled]="true"
      [matTooltip]="infoTooltip"
      icon="info"
      class="action-plan-side-pane-item__info"
    ></xi-icon-button>

    <xi-icon-button
      [disabled]="isInactive"
      [matTooltip]="t('dashboard-locked')"
      [matTooltipDisabled]="!isDashboardLocked"
      icon="remove_circle"
      (onClick)="onRemove()"
    ></xi-icon-button>
  </div>

  @if (isExpanded) {
    <div class="action-plan-side-pane-item__filters">
      @if (hasBreakdown) {
        <div class="action-plan-side-pane-item__filter-row">
          <xi-icon icon="research_panel"></xi-icon>
          <div class="action-plan-side-pane-item__filter">
            <span class="action-plan-side-pane-item__filter-label">{{ t('breakdown') }}</span>
            <div class="action-plan-side-pane-item__pill">
              <span class="action-plan-side-pane-item__pill-short"> {{ t('md') }} </span>
              <span class="action-plan-side-pane-item__pill-label">
                {{ actionPlan.metadata.breakdown }}
              </span>
              <xi-dropdown
                [disabled]="isInactive"
                [matTooltip]="t('dashboard-locked')"
                [matTooltipDisabled]="!isDashboardLocked"
                [data]="breakdownDs"
                select="single"
                type="icon"
                color="orca"
                [internalProps]="{ iconButton: { icon: 'settings' } }"
                (onValueChange)="onBreakdownAction($event.detail.selected.id)"
              ></xi-dropdown>
            </div>
          </div>
        </div>
      }
      <div class="action-plan-side-pane-item__filter-row">
        <xi-icon icon="research_panel"></xi-icon>
        <div class="action-plan-side-pane-item__filter">
          <span class="action-plan-side-pane-item__filter-label">{{ t('driver') }}</span>
          <div class="action-plan-side-pane-item__pill">
            <span class="action-plan-side-pane-item__pill-short"> {{ t('md') }} </span>
            <span class="action-plan-side-pane-item__pill-label">
              {{ actionPlan.metric_name }}
            </span>
            <xi-dropdown
              [disabled]="isInactive"
              [matTooltip]="t('dashboard-locked')"
              [matTooltipDisabled]="!isDashboardLocked"
              [data]="driverDs"
              select="single"
              type="icon"
              color="orca"
              [internalProps]="{ iconButton: { icon: 'settings' } }"
              (onValueChange)="onDriverAction($event.detail.selected.id)"
            ></xi-dropdown>
          </div>
        </div>
      </div>
      @if (hasFilter) {
        <div class="action-plan-side-pane-item__filter-row">
          <xi-icon icon="calendar"></xi-icon>
          <div class="action-plan-side-pane-item__filter">
            <span class="action-plan-side-pane-item__filter-label">{{ t('filters') }}</span>
            @for (filterPill of filterPills; track filterPill) {
              <div class="action-plan-side-pane-item__pill">
                <span class="action-plan-side-pane-item__pill-short">
                  {{ filterPill.shortLabel }}
                </span>
                <span class="action-plan-side-pane-item__pill-label">
                  <div *appMiddleEllipsize="filterPill.text; hideTooltip: true"></div>
                  <div *appMiddleEllipsize="filterPill.textExtra; hideTooltip: true"></div>
                </span>
                <xi-dropdown
                  [disabled]="isInactive"
                  [matTooltip]="t('dashboard-locked')"
                  [matTooltipDisabled]="!isDashboardLocked"
                  [data]="filterPill.dropdownObjects"
                  select="single"
                  type="icon"
                  color="orca"
                  [internalProps]="{ iconButton: { icon: 'settings' } }"
                  (onValueChange)="onFilterAction($event.detail.selected.id, filterPill)"
                ></xi-dropdown>
              </div>
            }
          </div>
        </div>
      }
      <div class="action-plan-side-pane-item__filter-row">
        <xi-icon icon="flag"></xi-icon>
        <div class="action-plan-side-pane-item__filter">
          <span class="action-plan-side-pane-item__filter-label">{{ t('target') }}</span>
          <div class="action-plan-side-pane-item__pill">
            <span
              class="action-plan-side-pane-item__pill-label action-plan-side-pane-item__pill-label--center"
            >
              {{ actionPlan.metric_target_value | number: '1.0-1' }}
            </span>
            <xi-dropdown
              [disabled]="isInactive"
              [matTooltip]="t('dashboard-locked')"
              [matTooltipDisabled]="!isDashboardLocked"
              [data]="targetDs"
              select="single"
              type="icon"
              color="orca"
              [internalProps]="{ iconButton: { icon: 'settings' } }"
              (onValueChange)="onTargetAction($event.detail.selected.id)"
            ></xi-dropdown>
          </div>
        </div>
      </div>
      @if (hasWeightField) {
        <div class="action-plan-side-pane-item__filter-row">
          <xi-icon icon="scale"></xi-icon>
          <div class="action-plan-side-pane-item__filter">
            <span class="action-plan-side-pane-item__filter-label">{{ t('weight') }}</span>
            <div class="action-plan-side-pane-item__pill">
              <span
                class="action-plan-side-pane-item__pill-label action-plan-side-pane-item__pill-label--center"
              >
                {{ weightFieldName }}
              </span>
              <xi-dropdown
                [disabled]="isInactive"
                [matTooltip]="t('dashboard-locked')"
                [matTooltipDisabled]="!isDashboardLocked"
                [data]="weightDs"
                select="single"
                type="icon"
                color="orca"
                [internalProps]="{ iconButton: { icon: 'settings' } }"
                (onValueChange)="onWeightAction($event.detail.selected.id)"
              ></xi-dropdown>
            </div>
          </div>
        </div>
      }
      <div class="action-plan-side-pane-item__filter-row">
        <xi-icon icon="calendar"></xi-icon>
        <div class="action-plan-side-pane-item__filter">
          <span class="action-plan-side-pane-item__filter-label">{{ t('dates') }}</span>
          <div class="action-plan-side-pane-item__pill">
            <span
              class="action-plan-side-pane-item__pill-label action-plan-side-pane-item__pill-label--center"
              >{{ actionPlan.creation_date | date: 'dd/MM/yyyy' }}</span
            >
            <xi-dropdown
              [disabled]="isInactive"
              [matTooltip]="t('dashboard-locked')"
              [matTooltipDisabled]="!isDashboardLocked"
              [data]="createdDateDs"
              select="single"
              type="icon"
              color="orca"
              [internalProps]="{ iconButton: { icon: 'settings' } }"
              (onValueChange)="onDateAction($event.detail.selected.id)"
            ></xi-dropdown>
          </div>
          <div class="action-plan-side-pane-item__pill">
            <span
              class="action-plan-side-pane-item__pill-label action-plan-side-pane-item__pill-label--center"
              >{{ actionPlan.due_date | date: 'dd/MM/yyyy' }}</span
            >
            <xi-dropdown
              [disabled]="isInactive"
              [matTooltip]="t('dashboard-locked')"
              [matTooltipDisabled]="!isDashboardLocked"
              [data]="dueDateDs"
              select="single"
              type="icon"
              color="orca"
              [internalProps]="{ iconButton: { icon: 'settings' } }"
              (onValueChange)="onDateAction($event.detail.selected.id)"
            ></xi-dropdown>
          </div>
        </div>
      </div>
    </div>
  }
</div>
